import { render, staticRenderFns } from "./peopleAuthorize.vue?vue&type=template&id=a2217b54&scoped=true&"
import script from "./peopleAuthorize.vue?vue&type=script&lang=js&"
export * from "./peopleAuthorize.vue?vue&type=script&lang=js&"
import style0 from "./peopleAuthorize.vue?vue&type=style&index=0&id=a2217b54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2217b54",
  null
  
)

export default component.exports